import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { useTheme } from '@material-ui/core'

export function MessagesSelectedIcon(props) {
	const theme = useTheme()
	const active_svg = <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='38' height='24' viewBox='0 0 38 24'>
		<g fill='none' fillRule='evenodd'>
			<path fill={theme.notificationDotColor} stroke='#000' strokeWidth='.75' d='M14.247 20.027l-1.782-4.902H17A6.625 6.625 0 0 0 23.625 8.5V7A6.625 6.625 0 0 0 17 .375H7A6.625 6.625 0 0 0 .375 7v1.5A6.625 6.625 0 0 0 7 15.125l.212.066 7.035 4.836z'/>
			<path fill='#FFF' stroke='#000' strokeWidth='.75' d='M24.774 23.074l1.778-4.449H23a5.625 5.625 0 0 1 0-11.25h9a5.625 5.625 0 0 1 0 11.25l-.199.057-7.027 4.392z'/>
		</g>
	</SvgIcon>
	const inactive_svg = <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='38' height='24' viewBox='0 0 38 24'>
	<g fill='#B6C0C5' fillRule='evenodd'>
		<path d='M17.122 0a7.002 7.002 0 0 1 6.879 5.694h-1.383a7 7 0 0 0-7 7v.603c0 .77.124 1.511.354 2.204l-2.906-.001 2.01 5.5-8.04-5.5H7a7 7 0 0 1-7-7V7a7 7 0 0 1 7-7h10.122z'/>
		<path d='M32 7h-9a6 6 0 1 0 0 12h2.998L24 24l8-5a6 6 0 1 0 0-12z'/>
	</g>
	</SvgIcon>
	return props.active ? active_svg : inactive_svg
}

export function ExtensionMenuIcon(props) {
	const theme = useTheme()
	let color = props.type === 'hover' ? theme.palette.primary.main : theme.drawerUserInfo.extButtonColor
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='65' height='20' viewBox='0 0 65 20'>
		<g fill='none' fillRule='evenodd'>
			<rect width='63.5' height='18.5' x='.75' y='.75' stroke={color} strokeWidth='1.5' rx='9.25'/>
			<text fill={color} fontFamily='ProximaNova-Extrabld, Proxima Nova, Arial' fontSize='11' fontWeight='600' letterSpacing='.5'>
				<tspan x='10' y='14'>EXT</tspan>
			</text>
			<path fill={color} d='M52.233 13.617a.4.4 0 0 1-.566 0l-4.384-4.384a.4.4 0 0 1 0-.566l1.29-1.29a.4.4 0 0 1 .566 0l2.81 2.81 2.811-2.81a.4.4 0 0 1 .566 0l1.29 1.29a.4.4 0 0 1 0 .566l-4.383 4.384z'/>
		</g>
	</SvgIcon>
}

export function CallsNavIcon(props) {
	const theme = useTheme()
	let gray = '#88969E'
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='38' height='26' viewBox='0 0 38 26'>
		<defs>
			<path id='calls_nav_path_a' d='M10.97 7.754l13.448 9.085a3 3 0 0 0 4.68-2.486V.439h-15.89a4 4 0 0 0-2.238 7.315z'/>
			<path id='calls_nav_path_c' d='M4.53 2.874l10.577 7.397a1.5 1.5 0 0 0 2.36-1.23V.146H5.391a1.5 1.5 0 0 0-.86 2.729z'/>
		</defs>
		<g fill='none' fillRule='evenodd'>
			<path d='M0 0h38v26H0z'/>
			<path fill={props.active ? '#FFF' : gray} fillRule='nonzero' stroke={props.active ? '#000' : gray} strokeWidth='.75' d='M22.867 21.426c-.868 1.075-4-.223-7.546-2.654-3.609-2.473-5.833-4.869-4.88-6.023.598-.732 1.436-1.748 2.512-3.047.277-.338.323-.775.14-1.135a16.08 16.08 0 0 1-1.688-5.245c-.084-.604-.691-1.024-1.378-.927l-5.584.784c-.682.096-1.154.67-1.07 1.272 1.912 13.6 15.404 22.94 30.184 20.863.687-.097 1.155-.668 1.07-1.272l-.724-5.148c-.085-.604-.691-1.023-1.378-.927-1.995.28-3.996.265-5.92-.038a1.34 1.34 0 0 0-1.226.457 515.457 515.457 0 0 0-2.512 3.04zm0 0l-.001.001.002-.002h-.001z'/>
			{props.active ?
				<>
					<g transform='translate(5.108 -1.723)'>
						<mask id='calls_nav_mask_b' fill='#fff'>
							<use xlinkHref='#calls_nav_path_a'/>
						</mask>
						<path fill={theme.palette.primary.main} stroke='#000' strokeWidth='.5' d='M16.392 1.973c-6.77 0-12.25 5.042-12.25 11.25 0 6.209 5.48 11.25 12.25 11.25s12.25-5.041 12.25-11.25c0-6.208-5.48-11.25-12.25-11.25zm0 2.96c4.96 0 8.99 3.707 8.99 8.29 0 4.584-4.03 8.29-8.99 8.29s-8.989-3.706-8.989-8.29c0-4.583 4.03-8.29 8.99-8.29z' mask='url(#calls_nav_mask_b)'/>
					</g>
					<g transform='translate(12.243 4.355)'>
						<mask id='calls_nav_mask_d' fill='#fff'>
							<use xlinkHref='#calls_nav_path_c'/>
						</mask>
						<path fill={theme.palette.primary.light} stroke='#000' strokeWidth='.5' d='M9.257.832c-4.011 0-7.25 2.834-7.25 6.313 0 3.478 3.239 6.312 7.25 6.312 4.01 0 7.25-2.834 7.25-6.312 0-3.479-3.24-6.313-7.25-6.313zm0 2.563c2.34 0 4.25 1.67 4.25 3.75 0 2.079-1.91 3.75-4.25 3.75s-4.25-1.671-4.25-3.75c0-2.08 1.91-3.75 4.25-3.75z' mask='url(#calls_nav_mask_d)'/>
					</g>
				</>
			: null}
		</g>
	</SvgIcon>
}

export function MessagesNavIcon(props) {
	const theme = useTheme()
	const readIcon = !props.active ? <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='38' height='24' viewBox='0 0 38 24'>
		<g fill='#B6C0C5' fillRule='evenodd'>
			<path d='M17.122 0a7.002 7.002 0 0 1 6.879 5.694h-1.383a7 7 0 0 0-7 7v.603c0 .77.124 1.511.354 2.204l-2.906-.001 2.01 5.5-8.04-5.5H7a7 7 0 0 1-7-7V7a7 7 0 0 1 7-7h10.122z'/>
			<path d='M32 7h-9a6 6 0 1 0 0 12h2.998L24 24l8-5a6 6 0 1 0 0-12z'/>
		</g>
	</SvgIcon>
	: <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='38' height='24' viewBox='0 0 38 24'>
		<g fill='none' fillRule='evenodd'>
			<path fill={theme.palette.primary.main} stroke='#000' strokeWidth='.75' d='M14.247 20.027l-1.782-4.902H17A6.625 6.625 0 0 0 23.625 8.5V7A6.625 6.625 0 0 0 17 .375H7A6.625 6.625 0 0 0 .375 7v1.5A6.625 6.625 0 0 0 7 15.125l.212.066 7.035 4.836z'/>
			<path fill='#FFF' stroke='#000' strokeWidth='.75' d='M24.774 23.074l1.778-4.449H23a5.625 5.625 0 0 1 0-11.25h9a5.625 5.625 0 0 1 0 11.25l-.199.057-7.027 4.392z'/>
		</g>
	</SvgIcon>

	const unreadIcon = <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='38' height='24' viewBox='0 0 38 24'>
		<defs>
			<path id='a' d='M23 7h9a6 6 0 1 1 0 12h-2.998L31 24l-8-5a6 6 0 1 1 0-12z'/>
			<filter id='b' width='141.7%' height='141.7%' x='-20.8%' y='-20.8%' filterUnits='objectBoundingBox'>
				<feOffset dx='-1' dy='1' in='SourceAlpha' result='shadowOffsetOuter1'/>
				<feColorMatrix in='shadowOffsetOuter1' result='shadowMatrixOuter1' values='0 0 0 0 0.352941176 0 0 0 0 0.4 0 0 0 0 0.42745098 0 0 0 0.497678103 0'/>
				<feMerge>
					<feMergeNode in='shadowMatrixOuter1'/>
					<feMergeNode in='SourceGraphic'/>
				</feMerge>
			</filter>
			<circle id='d' cx='7' cy='6' r='6'/>
			<filter id='c' width='116.7%' height='116.7%' x='-12.5%' y='-4.2%' filterUnits='objectBoundingBox'>
				<feOffset dx='-1' dy='1' in='SourceAlpha' result='shadowOffsetOuter1'/>
				<feComposite in='shadowOffsetOuter1' in2='SourceAlpha' operator='out' result='shadowOffsetOuter1'/>
				<feColorMatrix in='shadowOffsetOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0'/>
			</filter>
		</defs>
		<g fill='none' fillRule='evenodd'>
			{props.active ? 
				<>
					<path fill={theme.palette.primary.main} stroke='#000' strokeWidth='.75' d='M14.247 20.027l-1.782-4.902H17A6.625 6.625 0 0 0 23.625 8.5V7A6.625 6.625 0 0 0 17 .375H7A6.625 6.625 0 0 0 .375 7v1.5A6.625 6.625 0 0 0 7 15.125l.212.066 7.035 4.836z'/>
					<path fill='#fff' stroke='#000' strokeWidth='.75' d='M30.226 23.074l-1.778-4.449H32a5.625 5.625 0 0 0 0-11.25h-9a5.625 5.625 0 0 0 0 11.25l.199.057 7.027 4.392z'/>
				</>
				:
				<g fill='#B6C0C5' fillRule='evenodd'>
					<path d='M17.122 0a7.002 7.002 0 0 1 6.879 5.694h-1.383a7 7 0 0 0-7 7v.603c0 .77.124 1.511.354 2.204l-2.906-.001 2.01 5.5-8.04-5.5H7a7 7 0 0 1-7-7V7a7 7 0 0 1 7-7h10.122z'/>
					<path d='M32 7h-9a6 6 0 1 0 0 12h2.998L24 24l8-5a6 6 0 1 0 0-12z'/>
				</g>
			}
			<g transform='translate(25)'>
				<use fill='#000' filter='url(#c)' xlinkHref='#d'/>
				<circle cx='7' cy='6' r='5.625' fill={theme.notificationDotColor} stroke='#000' strokeLinejoin='square' strokeWidth='.75'/>
			</g>
		</g>
	</SvgIcon>

	return props.read ? readIcon : unreadIcon
}

export function VoicemailNavIcon(props) {
	const theme = useTheme()
	const readIcon = <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='38' height='24' viewBox='0 0 38 24'>
		{props.active ?
			<g fill='none' fillRule='evenodd' stroke='#000' strokeWidth='.75' transform='translate(.25 .375)'>
				<rect width='5' height='14' x='26' y='4.625' fill='#FFF' rx='2.5'/>
				<rect width='5' height='23.25' x='19.5' fill='#FFF' rx='2.5'/>
				<rect width='5' height='14' x='6.5' y='4.625' fill={theme.svgIcons.voicemailNavIcon.lite} rx='2.5'/>
				<rect width='5' height='5' x='32.5' y='9.125' fill='#FFF' rx='2.5'/>
				<rect width='5' height='6' y='8.625' fill={theme.svgIcons.voicemailNavIcon.main} rx='2.5'/>
				<rect width='5' height='10' x='13' y='6.625' fill={theme.svgIcons.voicemailNavIcon.xlite} rx='2.5'/>
			</g>
		:
			<g fill='#B6C0C5' fillRule='evenodd'>
				<rect width='5' height='14' x='26.25' y='5' rx='2.5'/>
				<rect width='5' height='24' x='19.75' rx='2.5'/>
				<rect width='5' height='14' x='6.75' y='5' rx='2.5'/>
				<rect width='5' height='6' x='32.75' y='9' rx='2.5'/>
				<rect width='5' height='6' x='.25' y='9' rx='2.5'/>
				<rect width='5' height='10' x='13.25' y='7' rx='2.5'/>
			</g>
		}
	</SvgIcon>

	const unreadIcon = <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='38' height='24' viewBox='0 0 38 24'>
		<defs>
			<path id='a' d='M23 7h9a6 6 0 1 1 0 12h-2.998L31 24l-8-5a6 6 0 1 1 0-12z'/>
			<filter id='b' width='141.7%' height='141.7%' x='-20.8%' y='-20.8%' filterUnits='objectBoundingBox'>
				<feOffset dx='-1' dy='1' in='SourceAlpha' result='shadowOffsetOuter1'/>
				<feColorMatrix in='shadowOffsetOuter1' result='shadowMatrixOuter1' values='0 0 0 0 0.352941176 0 0 0 0 0.4 0 0 0 0 0.42745098 0 0 0 0.497678103 0'/>
				<feMerge>
					<feMergeNode in='shadowMatrixOuter1'/>
					<feMergeNode in='SourceGraphic'/>
				</feMerge>
			</filter>
			<circle id='d' cx='7' cy='6' r='6'/>
			<filter id='c' width='116.7%' height='116.7%' x='-12.5%' y='-4.2%' filterUnits='objectBoundingBox'>
				<feOffset dx='-1' dy='1' in='SourceAlpha' result='shadowOffsetOuter1'/>
				<feComposite in='shadowOffsetOuter1' in2='SourceAlpha' operator='out' result='shadowOffsetOuter1'/>
				<feColorMatrix in='shadowOffsetOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0'/>
			</filter>
		</defs>
		<g fill='none' fillRule='evenodd'>
			{props.active ?
				<g fill='none' fillRule='evenodd' stroke='#000' strokeWidth='.75' transform='translate(.25 .375)'>
					<rect width='5' height='14' x='26' y='4.625' fill='#FFF' rx='2.5'/>
					<rect width='5' height='23.25' x='19.5' fill='#FFF' rx='2.5'/>
					<rect width='5' height='14' x='6.5' y='4.625' fill={theme.svgIcons.voicemailNavIcon.lite} rx='2.5'/>
					<rect width='5' height='5' x='32.5' y='9.125' fill='#FFF' rx='2.5'/>
					<rect width='5' height='6' y='8.625' fill={theme.svgIcons.voicemailNavIcon.main} rx='2.5'/>
					<rect width='5' height='10' x='13' y='6.625' fill={theme.svgIcons.voicemailNavIcon.xlite} rx='2.5'/>
				</g>
			:
				<g fill='#B6C0C5' fillRule='evenodd'>
					<rect width='5' height='14' x='26.25' y='5' rx='2.5'/>
					<rect width='5' height='24' x='19.75' rx='2.5'/>
					<rect width='5' height='14' x='6.75' y='5' rx='2.5'/>
					<rect width='5' height='6' x='32.75' y='9' rx='2.5'/>
					<rect width='5' height='6' x='.25' y='9' rx='2.5'/>
					<rect width='5' height='10' x='13.25' y='7' rx='2.5'/>
				</g>
			}
			<g transform='translate(25)'>
				<use fill='#000' filter='url(#c)' xlinkHref='#d'/>
				<circle cx='7' cy='6' r='5.625' fill={theme.notificationDotColor} stroke='#000' strokeLinejoin='square' strokeWidth='.75'/>
			</g>
		</g>
	</SvgIcon>

	return props.read ? readIcon : unreadIcon
}

// This one is in Zeplin's styleguide but doesn't seem like the one in the Zeplin's views
export function VoicemailNavIconNew(props) {
	const theme = useTheme()
	return props.active ?
		<SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='36' height='26' viewBox='0 0 36 26'>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h36v26H0z'/>
				<rect width='5' height='18' x='24.5' y='4' fill='#FFF' rx='2.5'/>
				<rect width='5' height='7' x='30.5' y='9.5' fill='#FFF' rx='2.5'/>
				<rect width='5' height='24' x='18.5' y='1' fill='#FFF' rx='2.5'/>
				<rect width='5' height='14' x='6.5' y='6' fill='#B3DEAB' rx='2.5'/>
				<rect width='5' height='5' x='.5' y='10.5' fill='#7FCD71' rx='2.5'/>
				<rect width='5' height='10' x='12.5' y='8' fill='#D9EFD4' rx='2.5'/>
			</g>
			{!props.read ?
				<g transform='translate(25)'>
					<use fill='#000' filter='url(#c)' xlinkHref='#d'/>
					<circle cx='7' cy='6' r='5.625' fill={theme.notificationDotColor} stroke='#000' strokeLinejoin='square' strokeWidth='.75'/>
				</g>
			: null}
		</SvgIcon>
		: <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='38' height='24' viewBox='0 0 38 24'>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h38v24H0z'/>
				<rect width='5' height='14' x='26.25' y='5' fill='#88969E' rx='2.5'/>
				<rect width='5' height='24' x='19.75' fill='#88969E' rx='2.5'/>
				<rect width='5' height='14' x='6.75' y='5' fill='#88969E' rx='2.5'/>
				<rect width='5' height='6' x='32.75' y='9' fill='#88969E' rx='2.5'/>
				<rect width='5' height='6' x='.25' y='9' fill='#88969E' rx='2.5'/>
				<rect width='5' height='10' x='13.25' y='7' fill='#88969E' rx='2.5'/>
			</g>
			{!props.read ?
				<g transform='translate(25)'>
					<use fill='#000' filter='url(#c)' xlinkHref='#d'/>
					<circle cx='7' cy='6' r='5.625' fill={theme.notificationDotColor} stroke='#000' strokeLinejoin='square' strokeWidth='.75'/>
				</g>
			: null}
		</SvgIcon>
}

export function FaxesNavIcon(props) {
	const theme = useTheme()
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='38' height='24' viewBox='0 0 38 24'>
		<g fill='none' fillRule='evenodd'>
			{props.active ?
			<>
				<path fill='#FFF' stroke='#000' strokeWidth='.75' d='M22.658 6.63l-3.207 12.13L30.32 22.53l7.19-16.787L25.626.49l-2.969 6.14z'/>
				<path fill='#E6EBEE' stroke='#000' strokeWidth='.75' d='M13.608.485L7.249 17.13c1.964 2.99 6.509 4.8 13.652 5.381 1.558-6.837 3.559-12.809 6.004-17.915L13.608.485z'/>
				<path fill={theme.palette.primary.main} stroke='#000' strokeWidth='.75' d='M4.528 2.323C2.783 7.928 1.389 14.317.348 21.49l14.23 2.199c1.156-5.336 1.708-9.41 1.657-12.215a16.728 16.728 0 0 0-.2-2.359c-.187-1.152-.785-2.348-1.639-3.45-.625-.806-1.375-1.51-1.613-1.605-1.635-.65-4.08-1.204-8.255-1.737zM.316 21.71z'/>
				<path fill='#000' d='M11.595 3.261c2.67.544 4.513 3.271 4.771 5.583.283 1.729.322 3.14.225 4.587-.336-6.166-2.97-8.44-4.028-9.014.344 2.62.545 5.474.289 7.638 1.671.91 3.373 2.245 3.297 5.315l.001-.207c-.04.289-.083.586-.127.893-.017.12-.363.005-.523.001.13-3.372-1.776-4.982-3.641-5.449.44-3.748.25-8.154-.264-9.347z'/>
				<path fill='#E6EBEE' d='M16.145 17.363c.076-3.07-1.626-4.404-3.297-5.315.256-2.164.055-5.018-.29-7.638 1.061.575 3.705 2.858 4.03 9.056-.013.686-.269 2.664-.443 3.897z'/>
			</>
			:
			<>
				<path fill='#88969E' d='M29.292 3.508c-.619-.168-2.13-.64-4.532-1.417a.1.1 0 0 1-.06-.134l.745-1.77a.2.2 0 0 1 .265-.105l12.186 5.389a.2.2 0 0 1 .103.262L30.603 23l-7.33-2.57c1.057-3.767 1.997-6.816 2.82-9.146 1.752-4.753 2.786-6.48 3.27-7.601.01-.024.046-.148-.071-.175z'/>
				<g fill='#88969E'>
					<path d='M13.638.078l13.648 4.22a.2.2 0 0 1 .121.278c-2.51 5.198-4.555 11.31-6.136 18.336-2.148-.163-4.073-.433-5.774-.812 1.604-8.762 1.445-10.945.859-13.272-.707-2.253-2.102-4.065-4.184-5.436l1.22-3.194a.2.2 0 0 1 .246-.12z'/>
					<path d='M4.34 1.912C2.527 7.665 1.087 14.247.021 21.657a.15.15 0 0 0 .126.17l14.19 2.192c.903-4.317 1.352-6.823 1.347-7.517-.764-1.914-2.55-3.68-3.739-3.904.421-3.42.297-8.136-.266-9.336-1.429-.42-3.632-.888-7.339-1.35z'/>
				</g>
			</>
			}
			<g fill='#FFF'>
				<path d='M8.795 14.025a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zM7.7 13.774a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.098-.28a.296.296 0 1 1 0 .592.296.296 0 0 1 0-.593zm-1.11-.241a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.097-.254a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm4.642-.116a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.075-.238a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.118-.257a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.09-.264a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.11-.26a.296.296 0 1 1 0 .592.296.296 0 0 1 0-.593zm4.661-.08a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.112-.246a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.084-.28a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.105-.246a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.093-.26a.296.296 0 1 1 0 .594.296.296 0 0 1 0-.593zm4.659-.113a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.093-.228a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.107-.274a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.1-.247a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.097-.264a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm4.657-.114a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.103-.228a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zM7.624 9a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zm-1.1-.228a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593zM5.437 8.5a.296.296 0 1 1 0 .593.296.296 0 0 1 0-.593z'/>
			</g>
			<text fill='#FFF' fontFamily='ProximaNova-Semibold, Proxima Nova' fontSize='1.25' fontWeight='500' transform='rotate(12 8.376 16.56)'>
				<tspan x='3.376' y='17.06'>Placeholder Title</tspan>
			</text>
			{!props.read ?
				<g transform='translate(25)'>
					<use fill='#000' filter='url(#c)' xlinkHref='#d'></use>
					<circle cx='7' cy='6' r='5.625' fill='#FA9927' stroke='#000' strokeLinejoin='square' strokeWidth='.75'></circle>
				</g>
			: null}
		</g>
	</SvgIcon>
}

export function ControlPanelNavIcon(props) {
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='37' height='24' viewBox='0 0 37 24'>
		<g fill='none' fillRule='evenodd'>
			<path fill='#88969E'
				d='M5 5v10a5 5 0 0 0 5 5h20a4 4 0 0 1-4 4H5a5 5 0 0 1-5-5v-9a5 5 0 0 1 4.783-4.995L5 5zm27-5a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H11a4 4 0 0 1-4-4V5a5 5 0 0 1 5-5h20z'/>
			<g fill='#364047'>
				<path
					d='M26.5 5a.5.5 0 0 0 .5.5l4.499-.001L31.5 10a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V5.01A.51.51 0 0 0 33 5v-.5a.5.5 0 0 0-.5-.5H27a.5.5 0 0 0-.5.5V5z'/>
				<path d='M26.5 10.5a.5.5 0 0 0 .707 0l5.657-5.657a.5.5 0 1 0-.707-.707L26.5 9.793a.5.5 0 0 0 0 .707z'/>
			</g>
		</g>
	</SvgIcon>
}

export function SettingsNavIcon(props) {
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'>
		<g fill='none' fillRule='evenodd'>
			<path d='M-4 0h36v28H-4z'/>
			<path fill={props.active ? '#FFF' : '#88969E'}
				d='M10.756.345a15.31 15.31 0 0 1 6.49.006l.607 3.637c1.19.418 2.31 1.028 3.302 1.817l3.6-1.315A14.106 14.106 0 0 1 26.693 7c.558.923.989 1.882 1.307 2.86l-2.992 2.319c.22 1.215.214 2.447-.003 3.64l2.993 2.32a13.841 13.841 0 0 1-3.238 5.372l-3.609-1.318a11.26 11.26 0 0 1-3.298 1.818l-.608 3.644c-2.163.47-4.381.452-6.49-.006l-.608-3.637a11.293 11.293 0 0 1-3.303-1.817L3.245 23.51A14.074 14.074 0 0 1 1.306 21 13.724 13.724 0 0 1 0 18.14l2.992-2.319a10.195 10.195 0 0 1 .004-3.64L0 9.861a13.843 13.843 0 0 1 3.24-5.373l3.609 1.32a11.198 11.198 0 0 1 3.297-1.819zM14 7.235c-3.72 0-6.747 3.035-6.747 6.765 0 3.73 3.027 6.765 6.747 6.765 3.719 0 6.745-3.035 6.745-6.765 0-3.73-3.026-6.765-6.745-6.765zm0 12.167a.503.503 0 1 1-.002 1.007.503.503 0 0 1 .001-1.007zm0-10.405c2.75 0 4.987 2.245 4.987 5.003s-2.237 5.003-4.987 5.003c-2.751 0-4.99-2.245-4.99-5.003s2.239-5.003 4.99-5.003zm4.52 8.823a.505.505 0 0 1 0 .713.501.501 0 0 1-.711 0 .505.505 0 0 1 0-.713.501.501 0 0 1 .71 0zm-8.33 0a.505.505 0 0 1 0 .713.502.502 0 0 1-.71 0 .505.505 0 0 1 0-.713.501.501 0 0 1 .71 0zm6.143-5.171a2.69 2.69 0 0 0-3.681-.99 2.706 2.706 0 0 0-.986 3.692 2.69 2.69 0 0 0 3.68.99 2.707 2.707 0 0 0 .987-3.692zm-8.223.847a.504.504 0 1 1-.002 1.007.504.504 0 0 1 .002-1.007zm11.779 0a.504.504 0 1 1-.001 1.007.504.504 0 0 1 0-1.007zm-1.37-4.029a.504.504 0 0 1-.71.713.505.505 0 0 1 0-.713.502.502 0 0 1 .71 0zm-8.329 0a.505.505 0 0 1 0 .713.5.5 0 0 1-.71 0 .502.502 0 1 1 .71-.713zm3.81-1.878a.503.503 0 1 1-.002 1.007A.503.503 0 0 1 14 7.589z'
			/>
		</g>
	</SvgIcon>
}


export function SupportNavIcon(props) {
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='36' height='26' viewBox='0 0 36 26'>
		<g fill='none' fillRule='evenodd'>
			<path d='M0 0h36v26H0z'/>
			<circle cx='18' cy='13' r='11.25' stroke='#CDD8EC' strokeWidth='3.5' opacity='.65'/>
			<g fill='#CDD8EC' fillRule='nonzero' stroke='#CDD8EC' strokeWidth='.5' opacity='.65'>
				<path d='M18.637 19.551h-1.1a.75.75 0 0 1-.75-.75v-.883a.75.75 0 0 1 .75-.75h1.1a.75.75 0 0 1 .75.75v.883a.75.75 0 0 1-.75.75zM21.486 12.539l-1.018.917c-.534.468-1.175 1.089-1.306 1.807-.034.287-.266.262-.308.262h-1.491a.5.5 0 0 1-.5-.5v-.295c0-1.102.511-1.055 1.33-1.777l1.417-1.256c.409-.359.665-.662.665-1.21 0-1.102-1.018-1.994-2.275-1.994s-2.275.892-2.275 1.994H13.45C13.45 8.284 15.486 6.5 18 6.5s4.55 1.784 4.55 3.987c0 .877-.404 1.474-1.064 2.052z'/>
			</g>
		</g>
	</SvgIcon>
}

export function AppsNavIcon(props) {
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='24' height='33' viewBox='0 0 24 33'>
		<g fill='none' fillRule='evenodd'>
			<path fill='#CDD8EC' d='M21 0a3 3 0 0 1 3 3v27a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h18zm-9 26a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 .893a1.607 1.607 0 1 1 0 3.214 1.607 1.607 0 0 1 0-3.214z' opacity='.647'/>
			<path fill='#0840A1' d='M4 2h16a2 2 0 0 1 2 2v18.5a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 22.5V4a2 2 0 0 1 2-2z' opacity='.446'/>
		</g>
	</SvgIcon>
}

export function LogoutNavIcon(props) {
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='36' height='27' viewBox='0 0 36 27'>
		<defs>
			<path id='logout_path' d='M0 0l10.608 2.212c1.432-.112 2.23.483 2.392 1.786.163 1.302-.17 2.635-1 3.998L13 13h10l1.003-5C22.953 6.75 22.62 5.416 23 4c.38-1.416 1.43-2.012 3.151-1.788L36 0v26H0V0z'/>
		</defs>
		<g fill='none' fillRule='evenodd'>
			<path d='M0 1h36v26H0z'/>
			<g transform='translate(0 1)'>
				<mask id='logout_mask' fill='#fff'>
					<use xlinkHref='#logout_path'/>
				</mask>
				<circle cx='18' cy='13' r='11' stroke='#CDD8EC' strokeWidth='4' mask='url(#logout_mask)' opacity='.65'/>
			</g>
			<rect width='4' height='13' x='16' fill='#CDD8EC' opacity='.65' rx='2'/>
		</g>
	</SvgIcon>
}

export function FlagIcon(props) {
 const theme = useTheme()
	let color = props.hover ? theme.palette.primary.main : '#5A666D'
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='20' height='24' viewBox='0 0 20 24'>
		<g fill='none' fillRule='evenodd'>
			<path stroke={color} d='M18.626 15.094c-1.592-.684-2.907-1.087-3.947-1.21-2.204-.212-3.402.183-4.591.485-.578.126-1.104.217-1.785.299-2.51.418-5.139.249-8.165-.527C1.401 11.883-.379 2.99 1.59 1.283c3.826 1.48 5.577 1.631 8.219 1.335 1.9-.259 3.36-.538 4.842-.464 1.317.143 2.642.47 3.975.982v11.958z'/>
			<path fill='#FFF' d='M18.018 14.022c-1.308-.572-4.395-1.97-7.762-1.271-.622.17-2.137.477-3.83.6-1.715.1-3.174-.525-4.84-1.053.366-4.884-.393-8.09.557-9.726 1.182.387 3.96 1.688 8.054 1.35 1.28-.208 2.391-.283 3.335-.225 1.646.134 2.763.383 4.18 1.05l.306 9.275z'/>
			<path fill={color} fillRule='nonzero' d='M18.5 0h.5a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z'/>
		</g>
	</SvgIcon>
}

export function AttachIcon(props) {
 const theme = useTheme()
	let disabledIcon = <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='44' height='44' viewBox='0 0 44 44'>
		<g fill='none' fillRule='evenodd' transform='translate(2)'>
			<circle cx='21' cy='21' r='21' fill='#CCD6DB'/>
			<path stroke='#FFF' strokeWidth='1.5' d='M14 16.074V26a6 6 0 1 0 12 0V14a4 4 0 1 0-8 0v11.343a2 2 0 1 0 4 0v-9.269'/>
		</g>
	</SvgIcon>

	let defaultIcon = <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='44' height='44' viewBox='0 0 44 44'>
		<defs>
			<circle id='attachement_icon_circle' cx='21' cy='21' r='21'/>
			<filter id='attachement_icon_filter' width='107.1%' height='107.1%' x='-5.4%' y='-1.8%' filterUnits='objectBoundingBox'>
				<feOffset dx='-1.5' dy='1.5' in='SourceAlpha' result='shadowOffsetOuter1'/>
				<feComposite in='shadowOffsetOuter1' in2='SourceAlpha' operator='out' result='shadowOffsetOuter1'/>
				<feColorMatrix in='shadowOffsetOuter1' values={theme.svgIcons.circleShadowFe}/>
			</filter>
		</defs>
		<g fill='none' fillRule='evenodd'>
			{props.hover ?
				<>
				<g transform='translate(2)'>
					<use fill='#000' filter='url(#attachement_icon_circle)' xlinkHref='#attachement_icon_filter'/>
					<circle cx='21' cy='21' r='20.25' fill={theme.palette.primary.main} stroke={theme.palette.primary.main} strokeLinejoin='square' strokeWidth='1.5'/>
				</g>
				<path stroke='#FFF' strokeWidth='1.5' d='M16 16.074V26a6 6 0 1 0 12 0V14a4 4 0 1 0-8 0v11.343a2 2 0 1 0 4 0v-9.269'/>
				</>
			:
				<>
				<use fill='#000' filter='url(#attachement_icon_circle)' xlinkHref='#attachement_icon_filter'/>
				<circle cx='23' cy='21' r='20.25' fill='#88969E' stroke='#88969E' strokeLinejoin='square' strokeWidth='1.5'/>
				<g stroke='#FFF' strokeWidth='1.5'>
					<path d='M16 16.074V26a6 6 0 1 0 12 0V14a4 4 0 1 0-8 0v11.343a2 2 0 1 0 4 0v-9.269'/>
				</g>
				</>
			}
		</g>
	</SvgIcon>

	return props.disabled ? disabledIcon : defaultIcon
}

export function SendIcon(props) {
	const theme = useTheme()
	let color = props.disabled ? '#E6EBEE' : '#CCD6DB'
	let notHoverIcon = <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='44' height='44' viewBox='0 0 44 44'>
		<g fill='none' fillRule='evenodd'>
			<circle cx='23' cy='21' r='21' fill={color}/>
			<g fill='#FFF'>
				<path d='M29.794 21.699a1 1 0 0 1-1.414 0L23 16.319l-5.38 5.38a1 1 0 0 1-1.414 0l-.8-.8a1 1 0 0 1 0-1.414l6.887-6.887a1 1 0 0 1 1.414 0l6.887 6.887a1 1 0 0 1 0 1.414l-.8.8z'/>
				<path d='M23.033 30.109h-.066a.75.75 0 0 1-.75-.75V15.958a.75.75 0 0 1 .75-.75h.066a.75.75 0 0 1 .75.75v13.4a.75.75 0 0 1-.75.75z'/>
			</g>
		</g>
	</SvgIcon>

	let hoverIcon = <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='44' height='44' viewBox='0 0 44 44'>
		<defs>
			<circle id='b' cx='23' cy='21' r='21'/>
			<filter id='a' width='107.1%' height='107.1%' x='-5.4%' y='-1.8%' filterUnits='objectBoundingBox'>
				<feOffset dx='-1.5' dy='1.5' in='SourceAlpha' result='shadowOffsetOuter1'/>
				<feComposite in='shadowOffsetOuter1' in2='SourceAlpha' operator='out' result='shadowOffsetOuter1'/>
				<feColorMatrix in='shadowOffsetOuter1' values={theme.svgIcons.circleShadowFe}/>
			</filter>
		</defs>
		<g fill='none' fillRule='evenodd'>
			<use fill='#000' filter='url(#a)' xlinkHref='#b'/>
			<circle cx='23' cy='21' r='20.25' fill={theme.palette.primary.main} stroke={theme.palette.primary.main} strokeLinejoin='square' strokeWidth='1.5'/>
			<g fill='#FFF'>
				<path d='M29.794 21.699a1 1 0 0 1-1.414 0L23 16.319l-5.38 5.38a1 1 0 0 1-1.414 0l-.8-.8a1 1 0 0 1 0-1.414l6.887-6.887a1 1 0 0 1 1.414 0l6.887 6.887a1 1 0 0 1 0 1.414l-.8.8z'/>
				<path d='M23.033 30.109h-.066a.75.75 0 0 1-.75-.75V15.958a.75.75 0 0 1 .75-.75h.066a.75.75 0 0 1 .75.75v13.4a.75.75 0 0 1-.75.75z'/>
			</g>
		</g>
	</SvgIcon>

	return props.disabled || !props.hover ? notHoverIcon : hoverIcon
}

export function AudioPlayerControlIcon(props) {
	const theme = useTheme()
	let values = {
		pause:		[0.211487417, 0.251952304, 0.278928895],
		pauseHover:	[0.247058824, 0.682352941, 0.160784314],
		play:		[0.136137293, 0.542544158, 0.0698753041]
	}
	let fillColor = props.type === 'pause' ? theme.palette.tertiary.dark : theme.palette.primary.main
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='60' height='60' viewBox='0 0 60 60'>

		<g fill='none' fillRule='evenodd'>
			{props.type === 'play' ?
				<>
					<use fill='#000' />
					<circle cx='31.154' cy='28.846' r='28.096' fill={fillColor} stroke={fillColor} strokeLinejoin='square' strokeWidth='1.5'/>

					<g transform='translate(2.308)'>
						<use fill='#000' />
						<use fill={fillColor}/>
					</g>
					<path fill='#FFF' d='M24.23 17.308v23.077l17.308-11.539z'/>
				</>
				:
				<>
				<use fill='#000'/>
				<circle cx='31.154' cy='28.846' r='28.096' fill='#FFF' stroke={fillColor} strokeLinejoin='square' strokeWidth='1.5'/>
				<rect width='6.923' height='23.077' x='21.923' y='17.308' fill={fillColor} rx='1'/>
				<rect width='6.923' height='23.077' x='33.462' y='17.308' fill={fillColor} rx='1'/>
				</>
			}
		</g>
	</SvgIcon>
}

export function Spinner(props) {
	const theme = useTheme()
	let color = theme.palette.primary.main
	return <SvgIcon {...props} width='205px' height='205px' viewBox='0 0 205 205' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
		<title>SPINNER@2x</title>
		<desc>Created with Sketch.</desc>
		<g id='SPINNER' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<rect id='Rectangle' fill={color} opacity='0.5' x='93.5' y='0' width='18' height='55' rx='9'></rect>
			<rect id='Rectangle' fill={color} transform='translate(102.500000, 177.500000) scale(1, -1) translate(-102.500000, -177.500000) ' x='93.5' y='150' width='18' height='55' rx='9'></rect>
			<rect id='Rectangle' fillOpacity='0.2' fill={color} x='0' y='93.5' width='55' height='18' rx='9'></rect>
			<rect id='Rectangle' fill={color} opacity='0.8' x='150' y='93.5' width='55' height='18' rx='9'></rect>
			<rect id='Rectangle' fill={color} opacity='0.6' transform='translate(140.000000, 37.548095) rotate(30.000000) translate(-140.000000, -37.548095) ' x='131' y='10.0480947' width='18' height='55' rx='9'></rect>
			<rect id='Rectangle' fill={color} transform='translate(65.000000, 167.451905) scale(1, -1) rotate(-30.000000) translate(-65.000000, -167.451905) ' x='56' y='139.951905' width='18' height='55' rx='9'></rect>
			<rect id='Rectangle' fill={color} opacity='0.95' transform='translate(140.000000, 167.451905) scale(1, -1) rotate(30.000000) translate(-140.000000, -167.451905) ' x='131' y='139.951905' width='18' height='55' rx='9'></rect>
			<rect id='Rectangle' fill={color} opacity='0.4' transform='translate(65.000000, 37.548095) rotate(-30.000000) translate(-65.000000, -37.548095) ' x='56' y='10.0480947' width='18' height='55' rx='9'></rect>
			<rect id='Rectangle' fill={color} opacity='0.3' transform='translate(37.548095, 65.000000) rotate(30.000000) translate(-37.548095, -65.000000) ' x='10.0480947' y='56' width='55' height='18' rx='9'></rect>
			<rect id='Rectangle' fill={color} opacity='0.9' transform='translate(167.451905, 140.000000) rotate(30.000000) translate(-167.451905, -140.000000) ' x='139.951905' y='131' width='55' height='18' rx='9'></rect>
			<rect id='Rectangle' fill={color} opacity='0.7' transform='translate(167.451905, 65.000000) scale(-1, 1) rotate(30.000000) translate(-167.451905, -65.000000) ' x='139.951905' y='56' width='55' height='18' rx='9'></rect>
			<rect id='Rectangle' fill={color} opacity='0.1' transform='translate(37.548095, 140.000000) scale(-1, 1) rotate(30.000000) translate(-37.548095, -140.000000) ' x='10.0480947' y='131' width='55' height='18' rx='9'></rect>
		</g>
	</SvgIcon>
}

export function VoicemailIcon(props) {
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='24' height='15' viewBox='0 0 24 15'>
		<g fill='#88969E' fillRule='evenodd'>
			<rect width='4' height='8' x='10' y='4' rx='2'/>
			<rect width='4' height='15' x='15' rx='2'/>
			<path d='M22 5a2 2 0 0 1 2 2v2a2 2 0 1 1-4 0V7a2 2 0 0 1 2-2z'/>
			<rect width='4' height='5' y='6' rx='2'/>
			<rect width='4' height='12' x='5' y='2' rx='2'/>
		</g>
	</SvgIcon>
}

export function NewChatIcon(props) {
	const theme = useTheme()
	let color = theme.palette[props.active ? 'primary' : 'tertiary'].main
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='26' height='21' viewBox='0 0 26 21'>
		<path fill='none' fillRule='evenodd' stroke={color} strokeWidth='1.5' d='M10.004 18.988l7.796-4.465h.564a6.886 6.886 0 0 0 0-13.773H7.636a6.886 6.886 0 0 0 0 13.773h4.902l-2.534 4.465z'/>
	</SvgIcon>
}

// StartNewButton icons - start
export function MakeCallIcon(props) {
	const theme = useTheme()
	let color = theme.palette.primary.main
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='44' height='30' viewBox='0 0 44 30'>
		<g fill='none' fillRule='evenodd'>
			<path d='M0 0h44v30H0z'/>
			<path fill={props.hover ? color : '#CCD6DB'} fillRule='nonzero' d='M11.854 12.998c2.722 4.719 8.199 8.623 13.559 11.024l4.16-3.677c.52-.458 1.266-.592 1.919-.408 2.117.617 3.264.892 5.617.892 1.05 0 1.891.742 1.891 1.667v5.836c0 .926-.841 1.668-1.89 1.668C19.355 30 5 17.325 5 1.667 5 .742 5.85 0 6.89 0h6.618c1.05 0 1.89.742 1.89 1.667 0 2.077.379 4.086 1.078 5.953.208.575.057 1.234-.463 1.693l-4.16 3.685z'/>
			<path fill={color} d='M36.625 0a.5.5 0 0 1 .5.5v4.375H41.5a.5.5 0 0 1 .5.5v2.25a.5.5 0 0 1-.5.5h-4.375V12.5a.5.5 0 0 1-.5.5h-2.25a.5.5 0 0 1-.5-.5V8.125H29.5a.5.5 0 0 1-.5-.5v-2.25a.5.5 0 0 1 .5-.5h4.375V.5a.5.5 0 0 1 .5-.5h2.25z'/>
		</g>
	</SvgIcon>
}

export function StartConversationIcon(props) {
	const theme = useTheme()
	let color = theme.palette.primary.main
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='44' height='30' viewBox='0 0 44 30'>
		<defs>
			<path id='start_conversation_path' d='M0 30V0h31.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5v11.755l8.998-.651.396-1.54a.75.75 0 0 1 .726-.562h1.63a.75.75 0 0 1 .75.75V30H0z'/>
		</defs>
		<g fill='none' fillRule='evenodd'>
			<path d='M0 0h44v30H0z'/>
			<mask id='start_conversation_mask' fill='#fff'>
				<use xlinkHref='#start_conversation_path'/>
			</mask>
			<path stroke={props.hover ? color : '#CCD6DB'} strokeWidth='3' d='M18.39 27.225L28.54 21.5H32.5c5.523 0 10-4.477 10-10s-4.477-10-10-10h-21c-5.523 0-10 4.477-10 10s4.477 10 10 10h9.848l-2.958 5.725z' mask='url(#start_conversation_mask)'/>
			<path fill={color} d='M38.625 0a.5.5 0 0 1 .5.5v4.375H43.5a.5.5 0 0 1 .5.5v2.25a.5.5 0 0 1-.5.5h-4.375V12.5a.5.5 0 0 1-.5.5h-2.25a.5.5 0 0 1-.5-.5V8.125H31.5a.5.5 0 0 1-.5-.5v-2.25a.5.5 0 0 1 .5-.5h4.375V.5a.5.5 0 0 1 .5-.5h2.25z'/>
		</g>
	</SvgIcon>
}

export function SendFaxIcon(props) {
	const theme		= useTheme()
	let mainColor	= theme.palette.primary.main
	let color1		= props.hover ? mainColor : '#CCD6DB'
	let transform	= props.hover ? 'rotate(12 10.563 22.657)' : 'rotate(12 10.574 22.553)'
	let x			= props.hover ? '3.563' : '3.574'
	let y			= props.hover ? '23.157' : '23.053'
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='44' height='32' viewBox='0 0 44 32'>
		<g fill='none' fillRule='evenodd'>
			<path fill={color1} d='M23.709 11.982l2.537-4.795 2.528.423a.2.2 0 0 0 .177-.058l1.761-1.822 13.065 3.812a.2.2 0 0 1 .125.276l-9.744 21.06a.2.2 0 0 1-.242.107l-14.392-4.562 4.17-14.403a.2.2 0 0 1 .015-.038z'/>
			<path fill={color1} stroke='#FFF' strokeWidth='1.75' d='M14.899 3.444l18.123 5.674-.44.913c-2.946 6.12-5.347 13.348-7.2 21.685l-.165.74-.756-.058c-8.958-.684-14.75-2.994-17.325-7.043a1.175 1.175 0 0 1-.108-1.045l7.871-20.866z'/>
			<path fill={color1} d='M5.47 4.823C3.173 11.866 1.35 19.94 0 29.043L16.712 32c2.119-7.485 3.145-12.99 3.079-16.516a20.104 20.104 0 0 0-.259-2.933c-.555-3.325-2.515-5.288-3.168-5.54-1.644-.63-4.481-1.415-10.894-2.188z'/>
			<path fill='#FFF' d='M19.647 23.299c-.65 3.632-1.447 7.443-1.645 8.775-.194.003-.648-.012-1.361-.047a6530.67 6530.67 0 0 0 1.801-10.231c.52-4.264-1.848-5.896-2.937-6.382-.413-.155-.975-.262-.728-.759.98-1.989 1.6-4.906 1.158-6.844-.399-1.036-1.063-1.202-1.713-1.51.58-.148 2.222.855 2.977 1.333 2.981 2.394 4.146 4.742 2.448 15.665zM44 1.5a.5.5 0 0 1 .5.5v7.75a.5.5 0 0 1-.5.5h-3.75V15a.5.5 0 0 1-.5.5h-5.5a.5.5 0 0 1-.5-.5v-4.75H29a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h15z'/>
			<path fill={mainColor} d='M38.25 0a.5.5 0 0 1 .5.5v4.75h4.75a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5h-4.75v4.75a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5V8.75H30.5a.5.5 0 0 1-.5-.5v-2.5a.5.5 0 0 1 .5-.5h4.75V.5a.5.5 0 0 1 .5-.5h2.5z'/>
			<text fill={props.hover ? '#fff' : '#000'} fontFamily='ProximaNova-Semibold, Proxima Nova' fontSize='1' fontWeight='500' transform={transform}>
				<tspan x={x} y={y}>Placeholder Title for Fax Icon</tspan>
			</text>
			<g fill={props.hover ? '#fff' : '#000'}>
				<path d='M11.024 19.235a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.52-.348a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.525-.39a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.542-.335a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.525-.352a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm6.45-.16a.412.412 0 1 1 0 .823.412.412 0 0 1 0-.824zm-1.493-.332a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.553-.357a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zM6.8 16.594a.412.412 0 1 1 0 .823.412.412 0 0 1 0-.823zm-1.543-.362a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm6.477-.11a.412.412 0 1 1 0 .823.412.412 0 0 1 0-.824zm-1.546-.342a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.506-.39a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.535-.34a.412.412 0 1 1 0 .823.412.412 0 0 1 0-.824zm-1.519-.36a.412.412 0 1 1 0 .823.412.412 0 0 1 0-.824zm6.473-.159a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.517-.317a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.54-.38a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.528-.344a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.524-.366a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm6.471-.16a.412.412 0 1 1 0 .825.412.412 0 0 1 0-.824zm-1.532-.316a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.534-.393a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.529-.317a.412.412 0 1 1 0 .824.412.412 0 0 1 0-.824zm-1.51-.38a.412.412 0 1 1 0 .825.412.412 0 0 1 0-.824z'/>
			</g>
		</g>
	</SvgIcon>
}
// StartNewButton icons - end

export function IconDownload(props) {
	const theme = useTheme()
	let color = theme.palette.primary.main
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36'>
		<g fill='none' fillRule='evenodd'>
			<g>
				<circle cx='18' cy='18' r='18' fill={color}/>
			</g>
			<g fill='#FFF' transform='translate(9.5 8.5)'>
				<path d='M3.02 6.518a1.25 1.25 0 0 1 1.768 0l3.711 3.711 3.713-3.711a1.25 1.25 0 1 1 1.768 1.767l-3.713 3.712-.706.708a1.5 1.5 0 0 1-2.122 0l-4.42-4.42a1.25 1.25 0 0 1 0-1.767z'/>
				<path d='M8.5.004c.483 0 .875.392.875.875v9.678a.75.75 0 0 1-.75.75h-.25a.75.75 0 0 1-.75-.75V.88c0-.483.392-.875.875-.875z'/>
				<rect width='16' height='3' x='.5' y='15.5' rx='1.5'/>
			</g>
		</g>
	</SvgIcon>
}

export function IconInfo(props) {
	const theme = useTheme()
	let color = theme.palette.primary.main
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36'>
		<g fill='none' fillRule='evenodd'>
			<circle cx='18' cy='18' r='18' fill={color}/>
			<g fill='#FFF' transform='translate(16 9)'>
				<rect width='4' height='11' y='7' rx='2'/>
				<rect width='4' height='5' rx='2'/>
			</g>
		</g>
	</SvgIcon>
}

export function AudioPlayerControlSliderIcon(props) {
	const theme				= useTheme()
	let mainColor			= theme.audioPlayer.controlSlider.defaultColor
	let lightGradientColor	= theme.audioPlayer.controlSlider.lightGradientColor
	let darkGradientColor	= theme.audioPlayer.controlSlider.darkGradientColor
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='40' height='31' viewBox='0 0 40 31'>
		<defs>
			<linearGradient id='control_slider_lg1' x1='50%' x2='50%' y1='0%' y2='99.021%'>
				<stop offset='0%' stopOpacity='0'/>
				<stop offset='80%' stopOpacity='.02'/>
				<stop offset='100%' stopOpacity='.04'/>
			</linearGradient>
			<linearGradient id='control_slider_lg2' x1='50%' x2='50%' y1='0%' y2='100%'>
				<stop offset='0%' stopColor='#FFF' stopOpacity='.12'/>
				<stop offset='20%' stopColor='#FFF' stopOpacity='.06'/>
				<stop offset='100%' stopColor='#FFF' stopOpacity='0'/>
			</linearGradient>
			<linearGradient id='control_slider_lg3' x1='93.745%' x2='40.276%' y1='67.436%' y2='43.399%'>
				<stop offset='0%' stopColor={lightGradientColor}/>
				<stop offset='100%' stopColor={darkGradientColor}/>
			</linearGradient>
			<filter id='d' width='127.3%' height='141.1%' x='-13.6%' y='-20.5%' filterUnits='objectBoundingBox'>
				<feGaussianBlur in='SourceGraphic' stdDeviation='1'/>
			</filter>
		</defs>
		<g fill='none' fillRule='evenodd'>
			<g strokeLinejoin='square' strokeWidth='.5'>
				<path fill={mainColor} stroke='url(#control_slider_lg1)' d='M7.605 1.967A9.75 9.75 0 0 0 .25 11.418v7.216a9.75 9.75 0 0 0 7.376 9.457c4.406 1.106 8.807 1.659 13.203 1.659 4.046 0 7.906-.469 11.58-1.406a9.75 9.75 0 0 0 7.341-9.447v-7.675c0-4.44-3-8.319-7.296-9.436C28.517.762 24.578.25 20.635.25c-4.168 0-8.511.572-13.03 1.717z' transform='translate(0 .5)'/>
				<path stroke='url(#control_slider_lg2)' d='M7.605 1.967A9.75 9.75 0 0 0 .25 11.418v7.216a9.75 9.75 0 0 0 7.376 9.457c4.406 1.106 8.807 1.659 13.203 1.659 4.046 0 7.906-.469 11.58-1.406a9.75 9.75 0 0 0 7.341-9.447v-7.675c0-4.44-3-8.319-7.296-9.436C28.517.762 24.578.25 20.635.25c-4.168 0-8.511.572-13.03 1.717z' transform='translate(0 .5)'/>
			</g>
			<path fill='url(#control_slider_lg3)' d='M12.936 9.614l6.315-1.375a5 5 0 0 1 2.193.015l5.686 1.319a5 5 0 0 1 3.87 4.87v1.123a5 5 0 0 1-3.86 4.868l-5.589 1.31a5 5 0 0 1-2.195.019l-6.41-1.383A5 5 0 0 1 9 15.493v-.994a5 5 0 0 1 3.936-4.885z' filter='url(#d)' transform='translate(0 .5)'/>
		</g>
	</SvgIcon>
}

export function MediaModalXBtn(props) {
	const theme			= useTheme()
	let color			= theme.palette.primary.main
	let defaultColor	= props.defaultcolor || '#FFF'
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'>
		<path fill={props.hover ? color : defaultColor} fillRule='evenodd' d='M6.793 5.267L15 13.475l8.207-8.208a.8.8 0 0 1 1.132 0l.394.394a.8.8 0 0 1 0 1.132L16.525 15l8.208 8.207a.8.8 0 0 1 0 1.132l-.394.394a.8.8 0 0 1-1.132 0L15 16.525l-8.207 8.208a.8.8 0 0 1-1.132 0l-.394-.394a.8.8 0 0 1 0-1.132L13.475 15 5.267 6.793a.8.8 0 0 1 0-1.132l.394-.394a.8.8 0 0 1 1.132 0z'/>
	</SvgIcon>
}

export function RemovePillIcon(props) {
	const theme			= useTheme()
	let mainColor		= theme.palette.primary.main
	let backgroundColor	= theme.svgIcons.removePillBackgroundColor
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26'>
		<g fill='none' fillRule='evenodd' transform='translate(.25 .75)'>
			<circle cx='12.5' cy='12.5' r='12.5' fill={backgroundColor} opacity='.9'/>
			<path fill={mainColor} d='M9.66 8.424l2.84 2.841 2.84-2.84a.6.6 0 0 1 .849 0l.387.386a.6.6 0 0 1 0 .849l-2.841 2.84 2.84 2.84a.6.6 0 0 1 0 .849l-.386.387a.6.6 0 0 1-.849 0l-2.84-2.841-2.84 2.84a.6.6 0 0 1-.849 0l-.387-.386a.6.6 0 0 1 0-.849l2.841-2.84-2.84-2.84a.6.6 0 0 1 0-.849l.386-.387a.6.6 0 0 1 .849 0z' opacity='.75'/>
		</g>
	</SvgIcon>
}

export function LabelCountIcon(props) {
	const theme					= useTheme()
	let backgroundColor			= `${theme.selector.labelCount.backgroundColor}${props.type === 'transparent' ? '00' : ''}`
	let borderColor				= `${theme.selector.labelCount.borderColor}${props.type === 'transparent' ? '00' : ''}`
	let secondBackgroundColor	= `${theme.selector.labelCount.secondBackgroundColor}${props.type === 'transparent' ? '00' : ''}`
	let secondBorderColor		= `${theme.selector.labelCount.secondBorderColor}${props.type === 'transparent' ? '00' : ''}`
	let width					= props.type === 'default' ? 40 : 39
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width={width} height='19' viewBox={`0 0 ${width} 19`}>
		<defs>
			<path id='label_count_icon_a' d='M0 0h35a4 4 0 0 1 4 4v15H0V0z'/>
		</defs>
		<g fill='none' fillRule='evenodd'>
			<mask id='label_count_icon_b' fill='#fff'>
				<use xlinkHref='#label_count_icon_a'/>
			</mask>
			{props.type === 'default' ?
				<path fill={backgroundColor} stroke={borderColor} d='M40.5 4.002V18.5H15.495c-2.345-.135-4.583-1.935-6.732-5.323-.94-1.371-3.589-5.67-7.96-12.914L.345-.495h.886L36-.5A4.5 4.5 0 0 1 40.5 4v.002z' mask='url(#label_count_icon_b)'/>
				:
				<path fill={secondBackgroundColor} stroke={secondBorderColor} d='M39.5 4.002V18.5H15.106c-2.294-.136-4.479-1.938-6.575-5.328C7.614 11.801 5.03 7.503.769.258L.326-.495H1.2L35-.5a4.5 4.5 0 0 1 4.5 4.498v.003z' mask='url(#label_count_icon_b)'/>
			}
		</g>
	</SvgIcon>
}

export function FaxReceivedIcon(props) {
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'>
		<g fill='#FFF' fillRule='evenodd'>
			<path d='M4.308 9.061L.244 9.83a.3.3 0 0 0-.244.295v3.913a.5.5 0 0 0 .313.464l8.5 3.424a.5.5 0 0 0 .374 0l8.5-3.424a.5.5 0 0 0 .313-.464v-3.913a.3.3 0 0 0-.244-.295l-4.064-.768a1.5 1.5 0 0 0-.882.1l-.186.082a.2.2 0 0 0 .042.38l3.688.737a.1.1 0 0 1 .01.194l-7.07 2.169a1 1 0 0 1-.587 0l-7.071-2.17a.1.1 0 0 1 .01-.193l3.688-.737a.2.2 0 0 0 .042-.38l-.186-.081a1.5 1.5 0 0 0-.882-.1zM8.752 0h.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5z'/>
			<path d='M12.717 5.191l.9.608a.5.5 0 0 1 .05.789l-3.986 3.528a1 1 0 0 1-1.31.013l-.919-.78 4.654-4.118a.5.5 0 0 1 .611-.04z'/>
			<path d='M5.283 5.191l-.9.608a.5.5 0 0 0-.05.789l3.986 3.528a1 1 0 0 0 1.31.013l.919-.78-4.654-4.118a.5.5 0 0 0-.611-.04z'/>
		</g>
	</SvgIcon>
}

export function FaxSentIcon(props) {
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='18' height='12' viewBox='0 0 18 12'>
		<path fill='#FFF' fillRule='evenodd' d='M-.01 3.294L18 0l-7.775 11.317-2.788-2.21-3.03 2.9.904-4.554 6.019-4-7.695 2.693z'/>
	</SvgIcon>
}

export function SpinnerIcon(props) {
	const theme			= useTheme()
	let spinnerColor	= theme.spinnerColor
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'>
		<g fill={spinnerColor} fillRule='evenodd'>
			<rect width='5.268' height='16.098' x='27.366' opacity='.3' rx='2.634'/>
			<rect width='5.268' height='16.098' x='27.366' y='43.902' opacity='.8' rx='2.634' transform='matrix(1 0 0 -1 0 103.902)'/>
			<rect width='16.098' height='5.268' y='27.366' rx='2.634'/>
			<rect width='16.098' height='5.268' x='43.902' y='27.366' opacity='.6' rx='2.634'/>
			<path d='M45 4.02a2.634 2.634 0 0 1 .964 3.598l-5.414 9.378a2.634 2.634 0 1 1-4.563-2.634l5.415-9.379A2.634 2.634 0 0 1 45 4.02z' opacity='.4'/>
			<path d='M15 55.98c1.26.728 2.87.296 3.598-.963l5.415-9.379a2.634 2.634 0 0 0-4.563-2.634l-5.414 9.378A2.634 2.634 0 0 0 15 55.981z' opacity='.85'/>
			<path d='M45 55.98a2.634 2.634 0 0 0 .964-3.598l-5.414-9.378a2.634 2.634 0 0 0-4.563 2.634l5.415 9.379A2.634 2.634 0 0 0 45 55.98z' opacity='.75'/>
			<path d='M15 4.02a2.634 2.634 0 0 1 3.598.963l5.415 9.379a2.634 2.634 0 1 1-4.563 2.634l-5.414-9.378A2.634 2.634 0 0 1 15 4.019z' opacity='.2'/>
			<path d='M7.618 14.036l9.378 5.414a2.634 2.634 0 1 1-2.634 4.563l-9.379-5.415a2.634 2.634 0 0 1 2.635-4.562z' opacity='.1'/>
			<path d='M45.638 35.987l9.379 5.415a2.634 2.634 0 0 1-2.635 4.562l-9.378-5.414a2.634 2.634 0 1 1 2.634-4.563z' opacity='.7'/>
			<path d='M52.382 14.036l-9.378 5.414a2.634 2.634 0 0 0 2.634 4.563l9.379-5.415a2.634 2.634 0 1 0-2.635-4.562z' opacity='.5'/>
			<path d='M14.362 35.987l-9.379 5.415a2.634 2.634 0 1 0 2.635 4.562l9.378-5.414a2.634 2.634 0 0 0-2.634-4.563z' opacity='.9'/>
		</g>
	</SvgIcon>
}

export function PlusCircleIcon(props) {
	const theme		= useTheme()
	let mainColor	= theme.contactModal.addIcon.mainColor
	let hoverColor	= theme.contactModal.addIcon.hoverColor
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'>
		<g fill='none' fillRule='evenodd'>
			<circle cx='11' cy='11' r='11' fill={props.hover ? hoverColor : mainColor}/>
			<path fill='#FFF' d='M11.75 6a.5.5 0 01.5.5v3.25h3.25a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5h-3.25v3.25a.5.5 0 01-.5.5h-1.5a.5.5 0 01-.5-.5v-3.25H6.5a.5.5 0 01-.5-.5v-1.5a.5.5 0 01.5-.5h3.25V6.5a.5.5 0 01.5-.5h1.5z'/>
		</g>
	</SvgIcon>
}

export function AddContactIcon(props) {
	const theme	= useTheme()
	let color	= theme.contactModal.titleColor
	return <SvgIcon {...props} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='40' height='35' viewBox='0 0 40 35'>
		<defs>
			<circle id='prefix__a' cx='17' cy='16.5' r='16.5'/>
			<path id='prefix__c' d='M25.5 2.875h1.513a.5.5 0 00.5-.5V0H0v35h40V15H29.875v-4.888L25 10.125v-6.75a.5.5 0 01.5-.5z'/>
		</defs>
		<g fill='none' fillRule='evenodd'>
			<path d='M0 0H40V35H0z'/>
			<g transform='translate(1)'>
				<mask id='prefix__b' fill='#fff'>
					<use xlinkHref='#prefix__a'/>
				</mask>
				<path fill={color} d='M30.202 38c-.066-1.305-.14-5.71-.247-6.677-.109-.99-.213-3.473-1.234-3.862-.475-.182-.175-.002-1.043-.579-1.105-.727-4.103-2.667-5.12-3.253-.475-.274-1.772-3.058-2.176-3.507-.316-.351-.554-.374-.731-.412-.784-.17-.757.258-.703-.52.016-.23-.008-.086.324-.466.723-.825.687-1.917.98-2.09.404-.238.9-.603 1.079-1.079.07-.184.146-.435.237-.684.15-.41.378-.918.28-1.33-.114-.48-.764-.175-.764-.175-.014-.007-.02-.031-.021-.063a1.22 1.22 0 00.15-.15c.284-.24.484-.767.543-1.054.104-.218.179-.505.179-.92 0-.247-.017-.49-.044-.731a4.35 4.35 0 00.016-.362c.015.043.03.085.039.117l.064.235-.049-.24a2.234 2.234 0 00-.053-.185c-.004-.44-.082-.86-.293-1.257-.044-.143-.09-.29-.146-.449-.054-.15-.227-.5-.436-.832a2.443 2.443 0 00-.446-.73 1.16 1.16 0 00-.138-.173l-.02-.03a3.715 3.715 0 00-.255-.322c.134.12.252.25.428.482-.296-.448-.422-.53-.81-.84a.495.495 0 00-.106-.11 1.427 1.427 0 01-.18-.145 3.05 3.05 0 00-.299-.413l-.096-.138a1.325 1.325 0 00-.467-.394.801.801 0 00-.08-.068 1.316 1.316 0 00-.487-.18c-.464-.176-1.019-.498-1.54-.515a2.683 2.683 0 00-.677-.092c-.033-.005-.062-.014-.096-.017a1.82 1.82 0 00-.175-.005 5.006 5.006 0 00-1.04.067c-.199.007-.407.051-.611.123-.523.091-1.067.536-1.276.873-.496-.055-1.152.274-1.568.591a2.094 2.094 0 00-.141.086c-.375.268-.618.516-.777.832-.5.514-.74.968-.741 1.539a2.36 2.36 0 00-.021.693l-.004.067c-.07.48-.08.938-.036 1.234.044.294.114.578.207.852.012.053.024.099.032.127.102.348.248.734.426 1.103.033.267.066.528.073.728.006.186-.026.27-.075.311-.088-.007-.365-.056-.424 0-.071.066-.105.157-.126.332-.02.175-.028.435.004.705.031.27.103.553.18.884.077.33.16.707.237.975.078.269.148.429.232.52.068.076.336.19.405.18l.022.047c.24.589.244 1.424.626 1.92.152.197.368.427.514.735.147.307.225.692.27.934.067.356.1.478-.147.624-.425.25-.685.412-1.077.658-.481.381-1.421 1.169-2.279 3.139.45-.281 1.111-.74 1.81-1.615-.685 1.182-1.413 1.613-2.86 2.441-1.454.748-3.315 1.067-4.433 3.818-.01.084.007 3.16 0 3.246-.014.348 0 .756-.035 1.327-.032.525-.105 3.69-.158 4.119h27.404z' mask='url(#prefix__b)' transform='matrix(-1 0 0 1 33 0)'/>
			</g>
			<g>
				<mask id='prefix__d' fill='#fff'>
					<use xlinkHref='#prefix__c'/>
				</mask>
				<circle cx='18' cy='17.5' r='16.5' stroke={color} strokeWidth='2' mask='url(#prefix__d)'/>
			</g>
			<path fill={color} d='M34.625 0a.5.5 0 01.5.5v4.375H39.5a.5.5 0 01.5.5v2.25a.5.5 0 01-.5.5h-4.375V12.5a.5.5 0 01-.5.5h-2.25a.5.5 0 01-.5-.5V8.125H27.5a.5.5 0 01-.5-.5v-2.25a.5.5 0 01.5-.5h4.375V.5a.5.5 0 01.5-.5h2.25z'/>
		</g>
	</SvgIcon>
}